<template style="height:100%">
  <div class="Add_factor_problem">
    <el-form label-width="80px" style="padding-top: 20px;margin-left: 20px;">
      <el-form-item label="量表名称">
        <el-input placeholder="量表名称" v-model="papername" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>

      <el-form-item v-if="pd" label="因子名称">

        <el-select v-model="factorName" placeholder="请选择因子名称" @change="getinfo()">
          <el-option v-for="(item,i) in options" :key="i" :label="item.factorName" :value="item.factorID">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-else label="因子名称">
        <el-input v-model="factorName"></el-input>
      </el-form-item>

      <el-form-item label="因子题目">
         <el-select v-model="questionIDs" multiple placeholder="请选择因子题目" @change="cshoi">
          <el-option v-for="(item,i) in options2" :key="i" :label="item.questionName" :value="item.questionID">
          </el-option>
        </el-select>
      </el-form-item>

      <ul style="margin-left:100px">
        <li v-for="(item,i) in oj" :key="i">
          <span>{{item.questionName}}</span> 
          <span>
            <el-form-item label="计分规则">
              <el-radio-group v-model="item.scoreType">
                <el-radio label="0">正向计分</el-radio>
                <el-radio label="1">反向计分</el-radio>
              </el-radio-group>
            </el-form-item>
          </span>
          
        </li>
      </ul>


      <el-form-item label="粗分公式记分方式">
        <el-radio-group v-model="paperInteTyp" placeholder="请选择粗分公式记分方式">
          <el-radio label="1">按照粗分</el-radio>
          <el-radio label="2">按照标准分</el-radio>
          <el-radio label="3">其它</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="因子粗分公式">
        <el-input type="textarea" v-model="calFormula" placeholder="说明:0 表示按照题目得分 为空表示不用计算 其它情况按照公式"></el-input>
      </el-form-item>

      <el-form-item label="因子平均分公式">
        <el-input type="textarea" v-model="averageFormula" placeholder="请按照格式配置此公式。"></el-input>
      </el-form-item>

      <div>
        <el-button type="primary" @click="addd()">添加</el-button>
        <table border="1">
          <tr>
            <th>开始年龄</th>
            <th>结束年龄</th>
            <th>性别</th>
            <th>标准差</th>
            <th>平均数</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item,i) in data" :key="i">
            <td><el-input style="width: 100px;" v-model="item.startAge"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.endAge"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.sex"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.sd"></el-input></td>
            <td><el-input style="width: 100px;" v-model="item.averageNum"></el-input></td>
            <td @click="dies(i)">删除</td>
          </tr>
        </table>
      </div>


      <el-form-item label="因子转换公式">
        <el-select v-model="tranFormula" placeholder="请选择因子转换公式">
          <el-option v-for="(item,i) in options3" :key="i" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="因子排序">
        <el-input v-model="lineNumber"></el-input>
      </el-form-item>

      <el-form-item label="因子基准分">
        <el-input v-model="baselineScore"></el-input>
      </el-form-item>

      <el-form-item label="因子题目显示方式">
        <el-radio-group v-model="isDisplayQuestion">
          <el-radio label="1">未做题显示</el-radio>
          <el-radio label="2">已做题显示</el-radio>
          <el-radio label="3">全部显示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="因子描述">
        <el-input type="textarea" v-model="remark" placeholder="请按照格式配置此公式。"></el-input>
      </el-form-item>

      <el-form-item label="标签">
        <el-input v-model="tagging"></el-input>
      </el-form-item>

      <el-form-item label="是否激活">
        <el-radio-group v-model="isActive">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-button v-if="pdxg" type="primary" @click="addfun(1)" style="margin-left:250px">确定</el-button>
      <el-button v-else type="primary" @click="addfun(2)" style="margin-left:250px">确定</el-button>
    </el-form>

    <el-dialog class="cscs" :visible.sync="dialogVisible" width="600px" style="height: 700px;" >
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>

  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
  export default {
    data() {

      return {
        questionIDs:[],//因子题目
        calFormula:'',//粗分公式
        tranFormula:'',//标准分
        lineNumber:'',//行序号
        factorType:'',//因子类别
        averageFormula:'',//因子平均分公式
        baselineScore:'',//因子基准分
        isDisplayQuestion:'1',//因子题目显示方式
        factorName:'',//因子名称
        tagging:'',//标签
        isActive:'1',//是否启用:0-无效 1-有效
        paperInteTyp:'1',//粗分公式记分方式
        remark:'',//备注
        paperCode:'',//量表id
        papername:'',//量表名称
        pd:true,//判断有没有因子
        dialogVisible:false,
        options:[],
        options2:[],
        options3:[],
        pdxg:true,
        oj:[],
        data:[],
      };
    },
    components:{
      scales_Pop
    },
    methods: {
      cshoi(da,y){
        this.oj = []
        for(var j = 0;j<this.options2.length;j++){
          for(var i = 0;i<this.questionIDs.length;i++){
            if(this.options2[j].questionID == this.questionIDs[i]){
              var ji = {
                questionID:this.questionIDs[i],
                scoreType:'1',
                questionName:this.options2[j].questionName
              }
              this.oj.push(ji)
            }
          }
        }
      },
      getinfo(data){//根据因子获取数据
        this.$Http_Post('paperconfig/factor/getinfo', {factorID:this.factorName}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.calFormula = res.Data.calFormula;
            this.tranFormula = res.Data.tranFormula;
            this.lineNumber = res.Data.lineNumber;
            this.averageFormula = res.Data.averageFormula;
            this.baselineScore = res.Data.baselineScore;
            this.isDisplayQuestion = res.Data.isDisplayQuestion.toString();
            this.isActive = res.Data.isActive.toString();
            this.tagging = res.Data.tagging;
            this.paperInteTyp = res.Data.paperInteTyp.toString();
            this.remark = res.Data.remark;
            this.data = res.Data.comTypes;
            var hi = [];
            for(var j = 0;j< res.Data.factorQuestionList.length;j++){
              hi.push(Number(res.Data.factorQuestionList[j].questionID))
            }
            this.questionIDs = hi
            this.oj = res.Data.factorQuestionList
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      dies(i){
        this.data.splice(i, 1)
      },
      addd(){
        var ss = {
          startAge:'0',
          endAge:'0',
          sex:'0',
          sd:'0',
          averageNum:'0',
        }
        this.data.push(ss)
    
      },
      addfun(val){
        if(val == 1){
          this.$Http_Post('paperconfig/factor/add', {
            calFormula:this.calFormula,
            tranFormula:this.tranFormula,
            lineNumber:this.lineNumber,
            factorType:this.factorType,
            averageFormula:this.averageFormula,
            baselineScore:this.baselineScore,
            isDisplayQuestion:this.isDisplayQuestion,
            tagging:this.tagging,
            isActive:this.isActive,
            paperInteTyp:this.paperInteTyp,
            remark:this.remark,
            paperCode:this.paperCode,
            papername:this.papername,
            questionIDs:this.questionIDs,
            factorName:this.factorName,
            factorQuestionList:this.oj,
            comTypes:this.data,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }else{
          this.$Http_Post('/paperconfig/factor/edit', {
            calFormula:this.calFormula,
            tranFormula:this.tranFormula,
            lineNumber:this.lineNumber,
            factorType:this.factorType,
            averageFormula:this.averageFormula,
            baselineScore:this.baselineScore,
            isDisplayQuestion:this.isDisplayQuestion,
            tagging:this.tagging,
            isActive:this.isActive,
            paperInteTyp:this.paperInteTyp,
            remark:this.remark,
            paperCode:[this.$route.query.paperCode][0],
            papername:this.papername,
            questionIDs:this.questionIDs,
            // factorName:this.factorName,
            factorID:this.factorName,
            factorQuestionList:this.oj,
            comTypes:this.data,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
            }else{
              this.Global.request_failure(res.Message);
            }
          });
          
        }
      },
      cel(){
        this.dialogVisible = true;
      },
      getmsg(val){//量表点击时子组件传过来值
        this.yz = [];
        this.papername = val.label;
        this.paperCode = val.val;
        this.$Http_Post('paperconfig/factor/list', {paperCode:val.val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if(res.Data.length > 0){
              this.pd = true;
              this.options = res.Data;
            }else{
              this.pd = false;
            }
          }else{
            this.Global.request_failure(res.Message);
          }
        });

        this.$Http_Post('paperconfig/questioncfg/list', {paperID:val.val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options2 = res.Data;
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
    },
    mounted(){
      if([this.$route.query.factorID][0]){
        this.$Http_Post('paperconfig/questioncfg/list', {paperID:[this.$route.query.paperCode][0]}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options2 = res.Data;
            this.$Http_Post('paperconfig/factor/getinfo', {factorID:[this.$route.query.factorID][0]}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.calFormula = res.Data.calFormula;
                this.tranFormula = res.Data.tranFormula;
                this.lineNumber = res.Data.lineNumber;
                this.averageFormula = res.Data.averageFormula;
                this.baselineScore = res.Data.baselineScore;
                this.isDisplayQuestion = res.Data.isDisplayQuestion.toString();
                this.isActive = res.Data.isActive.toString();
                this.tagging = res.Data.tagging;
                this.paperInteTyp = res.Data.paperInteTyp.toString();
                this.remark = res.Data.remark;
                this.factorName = res.Data.factorID;
                this.data = res.Data.comTypes;
                var hi = [];
                for(var j = 0;j< res.Data.factorQuestionList.length;j++){
                  hi.push(Number(res.Data.factorQuestionList[j].questionID))
                }
                this.questionIDs = hi;
                this.oj = [];
                for(var j = 0;j<this.options2.length;j++){
                  for(var i = 0;i<this.questionIDs.length;i++){
                    if(this.options2[j].questionID == this.questionIDs[i]){
                      var ji = {
                        questionID:this.questionIDs[i],
                        scoreType:'1',
                        questionName:this.options2[j].questionName
                      }
                      this.oj.push(ji);
                    }
                  }
                }
              }else{
                this.Global.request_failure(res.Message);
              }
            });
          }else{
            this.Global.request_failure(res.Message);
          }
        });
        this.papername = [this.$route.query.name][0];
        this.pdxg = false;
        this.$Http_Post('paperconfig/factor/list', {paperCode:[this.$route.query.paperCode][0]}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            if(res.Data.length > 0){
              this.pd = true;
              this.options = res.Data;
            }else{
              this.pd = false;
            }
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      }else{
        this.pdxg = true;
      }
      this.$Http_Post('paperconfig/factor/listtranformula', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.options3 = res.Data;
        }else{
          this.Global.request_failure(res.Message);
        }
      });
    }
  };
</script>
<style>
.Add_factor_problem {width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Add_factor_problem .el-input, .el-textarea{width: 500px;}
.Add_factor_problem .el-textarea__inner{height: 80px !important;}
.Add_factor_problem .el-form-item__label{width: 140px !important;}
</style>